const STORAGE_KEY_PREFIX = "vendor-documentation-contact-success";

export type VendorDocumentationContactSuccessPayload = {
  date: string;
  names: string[];
  vendorIds: string[];
};

export function readVendorDocumentationContactSuccess(
  orgId: string,
): VendorDocumentationContactSuccessPayload | null {
  try {
    const stored = sessionStorage.getItem(`${STORAGE_KEY_PREFIX}-${orgId}`);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (parsed?.date && Array.isArray(parsed?.names) && Array.isArray(parsed?.vendorIds)) {
      return parsed as VendorDocumentationContactSuccessPayload;
    }
    return null;
  } catch {
    return null;
  }
}

export function persistVendorDocumentationContactSuccess(
  orgId: string,
  payload: VendorDocumentationContactSuccessPayload,
): void {
  sessionStorage.setItem(`${STORAGE_KEY_PREFIX}-${orgId}`, JSON.stringify(payload));
}

export function clearVendorDocumentationContactSuccess(orgId: string): void {
  sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}-${orgId}`);
}
